import clsx from 'clsx';
import { FieldError } from 'react-hook-form';

export interface FieldWrapperProps {
  children: React.ReactNode;
  label?: React.ReactNode;
  labelSize?: 'xs' | 's' | 'm' | 'l' | 'xl';
  error?: FieldError;
  required?: boolean;
  className?: string;
  showError?: boolean;
  layoutForm?: 'vertical' | 'horizontal';
}

export function FieldWrapper({
  children,
  label,
  error,
  showError = true,
  labelSize,
  required,
  className,
  layoutForm = 'vertical'
}: FieldWrapperProps) {
  return (
    <div
      className={clsx('form-group', className, {
        'd-flex justify-content-start align-items-center gap-2': layoutForm === 'horizontal'
      })}
    >
      {label && (
        <label
          className={clsx('form-label', {
            'fs-9': labelSize === 'xs',
            'fs-8': labelSize === 's',
            'fs-7': labelSize === 'm',
            'fs-6': labelSize === 'l',
            'fs-5': labelSize === 'xl',
            required: required,
            'mb-0 w-50': layoutForm === 'horizontal'
          })}
        >
          {label}
        </label>
      )}
      {children}
      {error && showError && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{error.message}</div>
        </div>
      )}
    </div>
  );
}

export default FieldWrapper;
